import slugifyLib from 'slugify'

const REGEX = `[°ˇ¨*+=~_.,;(){}\`´'"?!:@#^\\[\\]//\\\\]`

export function slugify(string?: string, omitChars: string[] = []): string {
  if (!string) {
    return ''
  }

  return slugifyLib(string, {
    trim: true,
    lower: true,
    remove: new RegExp(getRegex(REGEX, omitChars), 'g')
  })
}

function getRegex(regex: string, ommitChars: string[]): string {
  if (!ommitChars?.length) {
    return regex
  }

  return ommitChars.reduce((output, char) => {
    return output.replace(char, '')
  }, regex)
}
